// Copyright (c) 2017 [these people](https://github.com/rollup/rollup-starter-lib/graphs/contributors)
// https://github.com/andreupifarre/preload-it
// node_modules\preload-it\dist\preload-it.js

// [カスタマイズ] ie11 に対応させています

export default class Preload {
  constructor() {
    this.status = []
    this.loaded = false
    this.onprogress = () => {}
    this.oncomplete = () => {}
    this.onfetched = () => {}
    this.fetch
    this.updateProgressBar
    this.preloadOne
    this.getItemByUrl
  }

  preloadOne(url, done) {
    const xhr = new XMLHttpRequest()
    xhr.open('GET', url, true)
    xhr.responseType = 'blob'
    xhr.onprogress = event => {
      if (!event.lengthComputable) return false
      let item = this.getItemByUrl(event.target.responseURL || url)
      item.completion = parseInt((event.loaded / event.total) * 100)
      item.downloaded = event.loaded
      item.total = event.total
      this.updateProgressBar(item)
    }
    xhr.onload = event => {
      let type = event.target.response.type
      let blob = new Blob([event.target.response], { type: type })
      let responseURL = event.target.responseURL || url
      let item = this.getItemByUrl(responseURL)
      item.fileName = responseURL.substring(responseURL.lastIndexOf('/') + 1)
      item.type = type
      item.size = blob.size
      done(item)
    }
    xhr.send()
  }

  updateProgressBar(item) {
    let sumCompletion = 0
    let maxCompletion = this.status.length * 100

    for (let itemStatus of this.status) {
      if (itemStatus.completion) {
        sumCompletion += itemStatus.completion
      }
    }
    let totalCompletion = parseInt((sumCompletion / maxCompletion) * 100)

    if (!isNaN(totalCompletion)) {
      this.onprogress({
        progress: totalCompletion,
        item: item
      })
    }
  }

  getItemByUrl(rawUrl) {
    for (let item of this.status) {
      if (item.url == rawUrl) return item
    }
  }

  fetch(list) {
    return new Promise((resolve, reject) => {
      this.loaded = list.length
      for (let item of list) {
        this.status.push({ url: item })
        this.preloadOne(item, item => {
          this.onfetched(item)
          this.loaded--
          if (this.loaded === 0) {
            this.oncomplete(this.status)
            resolve(this.status)
          }
        })
      }
    })
  }
}
